import { Project } from 'models/Project'

export const projects: Project[] = [
	{
		name: 'ThryvPay - iOS',
		description: 'iOS payment app for business',
		link: 'https://apps.apple.com/us/app/thryvpay/id1554576474',
	},
	{
		name: 'ThryvPay - Android',
		description: 'Android payment app for business',
		link: 'https://play.google.com/store/apps/details?id=com.thryv.thryvpay&hl=en_US&gl=US',
	},
	{
		name: 'NYC HOPE Survey - iOS',
		description: 'iOS app for NYC HOPE',
		link: 'https://apps.apple.com/us/app/nyc-hope-survey/id1549767507',
	},
	{
		name: 'NYC HOPE Survey - Android',
		description: 'Android app for NYC HOPE',
		link: 'https://play.google.com/store/apps/details?id=gov.nyc.dhs.oit.mobile.NYCHOPESurvey&hl=en_US&gl=US&pli=1',
	},
	{
		name: 'Landing member app - iOS',
		description: 'iOS app for Landing members',
		link: 'https://apps.apple.com/us/app/landing-furnished-apartments/id1487561384',
	},
	{
		name: 'Landing member app - Android',
		description: 'Android app for Landing members',
		link: 'https://play.google.com/store/apps/details?id=com.landingmember',
	},
	{
		name: 'Landing host app - iOS',
		description: 'iOS app for Landing hosts',
		link: 'https://apps.apple.com/us/app/landing-host/id1475124721',
	},
	{
		name: 'Landing host app - Android',
		description: 'Android app for Landing hosts',
		link: 'https://play.google.com/store/apps/details?id=com.homesiehost',
	},
	{
		name: 'EASYProcess - iOS',
		description: 'iOS app for K-Rise customers',
		link: 'https://apps.apple.com/us/app/easyprocess/id1484868854',
	},
	{
		name: 'EASYProcess - Android',
		description: 'Android app for K-Rise customers',
		link: 'https://play.google.com/store/apps/details?id=com.krisesystems.easyprocess',
	},
	{
		name: 'Kartheek Portfolio',
		description: 'Portfolio website using React',
		link: 'https://github.com/carteak004/kartheek-dev',
	},
	{
		name: 'Time Announcer',
		description: 'A mobile app to announce time at specified intervals',
		link: 'https://github.com/carteak004/timeAnnouncer/tree/main',
	},
]
